// extracted by mini-css-extract-plugin
export default {"root":"IconPriceTag_root__uM0k7"};